module.exports = __webpack_public_path__ + "static/media/mipac.012f1167.ico";